import { formatDate } from 'lib/helpers/utility';

import Actions from '../lib/Actions';

export const DEFAULT_COLUMNS = [
  {
    field: 'code',
    headerName: 'Code',
    maxWidth: 140,
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'name',
    headerName: 'Name'
  },
  {
    field: 'created_at',
    headerName: 'Created At',
    valueFormatter: ({ value }) => formatDate(value),
    cellClass: 'no-border'
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: (params) => <Actions data={params?.data} />,
    maxWidth: 200,
    minWidth: 200,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];
